import styled from "@emotion/styled";
import { Badge, Box, Button, Grid, Typography } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import CartServices from "src/services/cart";

import {
  HomeIcon,
  StoreIcon,
  CartIcon,
  ProfileIcon,
  OrdersIconBottomNavIcon,
} from "src/icons/navigations";
import { BasketIcon } from "src/icons/core";

import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useAuth } from "src/hooks/useAuth";

const NavigationBox = styled(Box)(({ theme }) => ({
  backgroundColor: "white",
  borderTop: `1.5px solid #F2F2F2`,
  display: "flex",
  alignItems: "center",
  height: theme.spacing(theme.mixins.toolbar.minHeight / 5),
}));

const BottomNavigation = () => {
  const router = useRouter();
  const { userData, isLogin } = useAuth();

  const {
    data: cart,
    isLoading,
    isSuccess,
  } = useQuery({
    enabled: isLogin,
    queryKey: ["cart"],
    queryFn: CartServices.fetchCart,
  });

  const isNavLinkActive = (...pathname) => {
    return pathname.includes(router.pathname);
  };

  const handleCartClick = (e) => {
    if (!isLogin) {
      router.push("/login");
      return;
    }
    if (!cart.data?.id) {
      toast.error("سبد خرید شما خالی می باشد");
      return;
    }
    router.push("/checkout");
  };
  return (
    <NavigationBox>
      <Grid
        container
        alignItems={"center"}
        justifyContent={"space-between"}
        my={"auto"}
      >
        <Grid item textAlign={"center"}>
          <Button
            LinkComponent={Link}
            href={"/"}
            color={isNavLinkActive("/") ? "primary" : "secondary"}
            sx={{ flexDirection: "column" }}
          >
            <HomeIcon sx={{ fill: "currentcolor" }} />
            <Typography textAlign={"center"} variant="caption2" fontSize={10}>
              خانه
            </Typography>
          </Button>
        </Grid>
        <Grid item textAlign={"center"}>
          <Button
            LinkComponent={Link}
            href={"/search"}
            color={
              isNavLinkActive("/search", "/search/[category]")
                ? "primary"
                : "secondary"
            }
            sx={{ flexDirection: "column" }}
          >
            <StoreIcon sx={{ fill: "currentcolor" }} />
            <Typography variant="caption2" fontSize={10}>
              فروشگاه
            </Typography>
          </Button>
        </Grid>
        <Grid item textAlign={"center"}>
          <Button
            // LinkComponent={Link}
            // href={'/checkout'}
            onClick={handleCartClick}
            color={isNavLinkActive("/checkout") ? "primary" : "secondary"}
            sx={{ flexDirection: "column" }}
          >
            <Badge
              color="primary"
              badgeContent={
                cart?.data?.carts?.reduce(
                  (previousValue, currentValue) =>
                    previousValue + currentValue.quantity,
                  0
                ) ?? 0
              }
              max={99}
              sx={{
                "& .MuiBadge-badge": {
                  // top: -4,
                  // right: 0,
                  boxShadow: (theme) =>
                    `0 0 0 2px ${theme.palette.background.paper}`,
                },
              }}
            >
              <CartIcon sx={{ fill: "currentcolor" }} />
            </Badge>

            <Typography variant="caption2" fontSize={10}>
              سبد خرید
            </Typography>
          </Button>
        </Grid>
        <Grid item textAlign={"center"}>
          <Button
            LinkComponent={Link}
            href={"/orders"}
            color={isNavLinkActive("/orders") ? "primary" : "secondary"}
            sx={{ flexDirection: "column" }}
          >
            <OrdersIconBottomNavIcon sx={{ fill: "currentcolor" }} />
            <Typography variant="caption2" textAlign={"center"} fontSize={10}>
              سفارشات
            </Typography>
          </Button>
        </Grid>
        <Grid item textAlign={"center"}>
          <Button
            LinkComponent={Link}
            href={"/account"}
            color={isNavLinkActive("/account") ? "primary" : "secondary"}
            sx={{ flexDirection: "column" }}
          >
            <ProfileIcon sx={{ fill: "currentcolor" }} />
            <Typography variant="caption2" textAlign={"center"} fontSize={10}>
              پروفایل
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </NavigationBox>
  );
};

export default BottomNavigation;
